module.exports = __webpack_public_path__ + "static/media/copacetic.1be9f442.png";